import { createAsyncThunk } from '@reduxjs/toolkit';
import reportService from './Report.service';
import { ReportFetchParams } from './Report.type';
import { errorHandlerThunk } from '../App/App.thunk';

export const getReportThunk = createAsyncThunk(
  'report/getReportThunk',
  async (params: ReportFetchParams, thunkApi) => {
    try {
      const response = params?.subGroupBy
        ? await reportService.getMultipleReport(params)
        : await reportService.getReport(params);
      return { data: response.data.data, params };
    } catch (error) {
      throw thunkApi.dispatch(errorHandlerThunk(error));
    }
  },
);
